import { z } from "zod";
import { KycPrivMode } from "./KycPrivForm.types";

const req = z.string().min(1, "Pakrevd");
const opt = z.string().optional().default("");

export function createKycPrivSchema(mode: KycPrivMode = "combined") {
  const kycReq = mode === "mifid" ? opt : req;
  const mifidReq = mode === "kyc" ? opt : req;

  return z.object({
    // -- Personopplysninger --------------------------------------------------
    personId: z.string(),
    personName: z.string(),
    address: req,
    zip: req,
    city: req,
    phone: req,
    email: req,
    taxCountry: req,
    nationality: req,
    pep: kycReq,
    pepCustom: opt,

    // -- AML/KYC -------------------------------------------------------------
    amlEmploymentSituation: kycReq,
    amlEmploymentSituationCustom: opt,
    amlPurposeOfCustomerRelationship: kycReq,
    amlPurposeOfCustomerRelationshipCustom: opt,
    amlInvestedPortfolio: kycReq,
    amlAnnualDeposits: kycReq,
    amlSourceOfFunds: kycReq,
    amlSourceOfFundsCustom: opt,
    amlSourceOfWealth: opt,
    amlSourceOfWealthCustom: opt,
    amlManagedOnBehalfOfOthers: kycReq,
    amlManagedOnBehalfOfOthersCustom: opt,
    amlTransfersAbroad: kycReq,
    amlTransfersAbroadCustom: opt,
    amlCryptoCurrency: kycReq,

    // -- MIFID - Kunnskap og erfaring ----------------------------------------
    mifidKnowledgeOfMutualFunds: mifidReq,
    mifidExperienceOfMutualFunds: mifidReq,
    mifidTradingFrequencyOfMutualFunds: mifidReq,
    mifidPeriodOfMutualFunds: mifidReq,
    mifidKnowledgeOfListedStocks: mifidReq,
    mifidExperienceOfListedStocks: mifidReq,
    mifidTradingFrequencyOfListedStocks: mifidReq,
    mifidPeriodOfListedStocks: mifidReq,
    mifidKnowledgeOfUnlistedStocks: mifidReq,
    mifidExperienceOfUnlistedStocks: mifidReq,
    mifidTradingFrequencyOfUnlistedStocks: mifidReq,
    mifidPeriodOfUnlistedStocks: mifidReq,
    mifidKnowledgeOfBonds: mifidReq,
    mifidExperienceOfBonds: mifidReq,
    mifidTradingFrequencyOfBonds: mifidReq,
    mifidPeriodOfBonds: mifidReq,
    mifidKnowledgeOfComplexInvestments: mifidReq,
    mifidExperienceOfComplexInvestments: mifidReq,
    mifidTradingFrequencyOfComplexInvestments: mifidReq,
    mifidPeriodOfComplexInvestments: mifidReq,
    mifidRelevantExperienceEducation: mifidReq,

    // -- MIFID - Finansiell situasjon ----------------------------------------
    mifidTotalNetWealth: opt,
    mifidLiquidInvestableWealth: opt,
    mifidGrossAnnualIncome: opt,
    mifidLiquidityBuffer: opt,
    mifidDebtBurden: opt,
    mifidIncomeStability: mifidReq,
    mifidEarliestWithdrawal: mifidReq,

    // -- MIFID - Risiko og formal ---------------------------------------------
    mifidMainInvestmentPurpose: mifidReq,
    mifidRiskToleranceVolatility: mifidReq,
    mifidMarketDropResponse: mifidReq,
    mifidLiquidityNeed: mifidReq,
    mifidValueDeclineImpact: mifidReq,

    // -- MIFID - Baerekraft ---------------------------------------------------
    mifidEsgPreference: mifidReq,
    mifidEsgPreferenceType: opt,
  });
}

export const kycPrivSchema = createKycPrivSchema("combined");
export type KycPrivData = z.infer<typeof kycPrivSchema>;
